import React, { memo, useContext, useEffect, useMemo, useRef } from 'react'
import { FunctionComponent } from 'react'
import { musicContext } from '@hoc/WithMusic'
import defaultMusicInput from './no-album.jpg'
import { SurveyContext } from '@context/SurveyContext'
import { AlbumEntry } from '@models/Music'
import { useComponentSize } from '@hooks/useComponentSize'
import GraphicCell from '@components/AnswerInput/GraphicCell/GraphicCell'
import './AlbumInput.scss'
import AlbumImage from './AlbumImage'

interface AlbumCarouselProps {}

const AlbumCarousel: FunctionComponent<AlbumCarouselProps> = () => {
  const { albums, selectedAlbum, selectAlbum, lookupAlbums } = useContext(musicContext)
  const { currentAnswer } = useContext(SurveyContext)
  const componentRef = useRef<HTMLDivElement>(null)

  const { width } = useComponentSize(componentRef)

  useEffect(() => {
    if (currentAnswer) {
      lookupAlbums((currentAnswer as AlbumEntry).artistId, (currentAnswer as AlbumEntry).artist)
      selectAlbum(currentAnswer as AlbumEntry)
    }
  }, [])

  const size = useMemo(() => {
    if (width) {
      // size in px for each graphic cell must have to get columnSize column
      const widthPadding = 8 * 2
      const gapSize = 5.6
      const totalGapSize = 2 * gapSize
      return (1 / 2) * (width - widthPadding) - totalGapSize
    }
    return undefined
  }, [width])

  useEffect(() => {
    if (albums.length === 1) {
      const [album] = albums
      selectAlbum(album)
    }
  }, [albums])

  if (albums.length === 1) {
    <div className="album-image">
      <AlbumImage />
    </div>
  }

  return (
    <div className="album-input" ref={componentRef}>
      {albums.map((album) => {
        const { id, artworkUrl, title } = album
        return (
          <span className="graphic-choice" key={id} onClick={() => selectAlbum(album)}>
            <GraphicCell
              selected={id === selectedAlbum?.id}
              graphicSrc={artworkUrl}
              size={size}
              label={title}
              labeSize="large"
              fallbackGraphicSrc={defaultMusicInput}
              showLabel
            />
          </span>
        )
      })}
    </div>
  )
}

export default memo(AlbumCarousel)
